import { default as MuiTableRow, TableRowProps } from '@mui/material/TableRow'
import * as React from 'react'

export const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>((props, ref) => {
  return <MuiTableRow ref={ref} {...props} />
})

export default TableRow
